import { apiBlobRequest, apiRequest } from './http';
import type { ApiItemResponse, ApiListResponse } from '../types/api';

export interface TryptiqueListQuery {
  page?: number;
  pageSize?: number;
  referenceTryptique?: string;
  partnerCode?: string;
  regime?: '009' | '900';
  flow?: 'IMPORT_D17' | 'EXPORT_D20' | 'UNKNOWN';
  fonctionMessage?: string;
  validationStatus?: string;
  processingStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface TryptiqueListItem {
  id: string;
  filename: string | null;
  partnerCode: string | null;
  referenceTryptique: string | null;
  regime: string;
  flow: string;
  fonctionMessageCode: string | null;
  fonctionMessageLabel: string;
  lifecycleEventLabel: string | null;
  dateEnregistrementRaw: string | null;
  dateEnregistrement: string | null;
  dateMainleveeRaw: string | null;
  dateMainlevee: string | null;
  validationStatus: string;
  processingStatus: string;
  processingError: string | null;
  correlationId: string;
  inboundDocumentId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface TryptiqueDetail extends TryptiqueListItem {
  technicalMessageNumber: string;
  as2MessageId: string | null;
  rootElement: string;
  numeroMessage: string | null;
  rawXmlAvailable: boolean;
  normalizedJson: Record<string, unknown> | null;
  validationReport: { errors?: string[]; warnings?: string[] } | null;
  timeline: Array<{ at: string; status: string; detail?: string }>;
}

function queryString(query: TryptiqueListQuery): string {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.set(key, String(value));
  });
  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export async function listTryptiqueMessages(query: TryptiqueListQuery): Promise<ApiListResponse<TryptiqueListItem>> {
  return apiRequest<ApiListResponse<TryptiqueListItem>>(`/customs/tryptique${queryString(query)}`);
}

export async function getTryptiqueMessage(id: string): Promise<TryptiqueDetail> {
  const response = await apiRequest<ApiItemResponse<TryptiqueDetail>>(`/customs/tryptique/${id}`);
  return response.data;
}

export async function getTryptiqueRawXml(id: string): Promise<string> {
  const { blob } = await apiBlobRequest(`/customs/tryptique/${id}/raw`);
  return blob.text();
}
